import type { ChatMessage, ResponseBlock } from '../types';

/** Blokktyper som vises i resultatpanelet (tekst og feil står i samtalen, SQL bak «SQL»-knappen). */
const RESULT_BLOCK_TYPES: ResponseBlock['type'][] = ['table', 'chart', 'kpi', 'funnel', 'heatmap', 'treemap', 'file'];

/** Svaret har noe å vise i resultatpanelet (Compass-visning eller datablokker fra eldre svar). */
export function hasResult(message: ChatMessage | undefined | null): boolean {
    if (!message || message.role !== 'assistant' || message.isLoading) return false;
    if (message.view && message.datasets) return true;
    return !!message.blocks?.some(b => RESULT_BLOCK_TYPES.includes(b.type));
}

/** Datablokkene et eldre svar (uten visning) viser i resultatpanelet. */
export function resultBlocks(message: ChatMessage): { block: ResponseBlock; index: number }[] {
    return (message.blocks ?? [])
        .map((block, index) => ({ block, index }))
        .filter(({ block }) => RESULT_BLOCK_TYPES.includes(block.type));
}

/** Spørsmålet som ga svaret (nærmeste brukermelding før). */
export function promptFor(messages: ChatMessage[], messageId: string): string {
    const idx = messages.findIndex(m => m.id === messageId);
    for (let i = idx - 1; i >= 0; i--) {
        if (messages[i].role === 'user') return messages[i].content;
    }
    return '';
}

/** Alle SQL-er i svaret (per datasett for visninger, ellers generatedSQL). */
export function resultSql(message: ChatMessage): { id: string; sql: string }[] {
    if (message.datasets) {
        const list = Object.values(message.datasets).filter(d => !!d.sql).map(d => ({ id: d.id, sql: d.sql as string }));
        if (list.length > 0) return list;
    }
    return message.generatedSQL ? [{ id: 'main', sql: message.generatedSQL }] : [];
}
